module.exports = __webpack_public_path__ + "img/botaoVotar.15b974e8.png";